import { Controller } from "@hotwired/stimulus";

// Feedback 👍/👎 sur un item de FAQ. stopPropagation obligatoire :
// le conteneur parent porte click->faqs#toggle (accordéon).
export default class extends Controller {
  static targets = ["buttons", "thanks"];
  static values = { key: String, url: String };

  submit(event) {
    event.preventDefault();
    event.stopPropagation();

    const helpful = event.currentTarget.dataset.helpful === "true";
    const token = document.querySelector('meta[name="csrf-token"]')?.content;

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
      },
      body: JSON.stringify({ question_key: this.keyValue, helpful }),
    }).catch(() => {});

    this.buttonsTarget.classList.add("hidden");
    this.thanksTarget.classList.remove("hidden");
  }
}
